import React, { useContext, useEffect } from 'react'
import './index.scss'
import { StoresContext } from '@App/contexts'
import { observer } from 'mobx-react'
import { CourierInboxPopupMenu, useCourier } from '@trycourier/courier-react'
import { ICONS } from '@Const/common'
import { useSafeNavigate } from '@App/navigation/use-safe-navigate'
const NotificationInbox = () => {
    const { notificationStore, authStore, userStore } = useContext(StoresContext)
    const notificationToken = notificationStore.notificationToken
    const courier = useCourier()
    const safeNavigate = useSafeNavigate()
    useEffect(() => {
        if (userStore.userInfo?.exposedId && authStore.isLoggedIn && !!notificationToken) {
            courier.shared.signIn({ userId: userStore.userInfo.exposedId, jwt: notificationToken })
        }
    }, [notificationToken])

    if (notificationToken) {
        return (
            <div className="courier-inbox-wrapper">
                <CourierInboxPopupMenu
                    popupAlignment="top-right"
                    mode="light"
                    renderMenuButton={(props) => (
                        <button type="button" className="notification-bell">
                            <img src={ICONS.notifications} alt="Notifications" />
                            {(props?.totalUnreadCount ?? 0) > 0 && <span className="notification-bell__unread-dot" />}
                        </button>
                    )}
                    onMessageClick={({ message }) => {
                        safeNavigate(message.actions?.[0]?.href)
                    }}
                    onMessageActionClick={({ action }) => {
                        safeNavigate(action.href)
                    }}
                />
            </div>
        )
    } else {
        return null
    }
}

export default observer(NotificationInbox)
